module.exports = __webpack_public_path__ + "img/dda44aa.jpg";